import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AboutRoutingModule } from './about-routing.module';
import { AboutComponent } from './about.component';
import { P0Component } from './p0/p0.component';
import { P1Component } from './p1/p1.component';
import { P2Component } from './p2/p2.component';
import { P3Component } from './p3/p3.component';
import { P4Component } from './p4/p4.component';
import { PublicModule } from './../../public/public.module';


@NgModule({
  imports: [
    CommonModule,
    AboutRoutingModule,
    PublicModule
  ],
  declarations: [AboutComponent, P0Component, P1Component, P2Component, P3Component, P4Component]
})
export class AboutModule { }



// WEBPACK FOOTER //
// ./src/app/tw/about/about.module.ts